module.exports = __webpack_public_path__ + "media/images/logo_h@2x-62b0dc749095b6629d54679aa14926a0.png";